import { useEffect, useMemo } from 'react';
import { useApiUrl } from '../../global/config/useApiUrl';
import { useCampfireFetch } from '../../global/network/useCampfireFetch';

export interface ApplicantHoldProfile {
  profileId: string;
  firstName: string;
  lastName: string;
  preferredName: string;
  avatarUrl: string | null;
}

export interface ApplicantHold {
  applicationActivityId: string;
  profile: ApplicantHoldProfile;
  stage: 'profile' | 'tasks' | 'pending_review' | 'ready';
  status: string;
  eventSelections: Array<{ date: string; sessionIds: string[] }>;
}

interface ApplicantHoldsResponse {
  applicantHolds: ApplicantHold[];
}

export function useApplicantHolds(activityId: string | null) {
  const apiUrl = useApiUrl();
  const campfireFetch = useCampfireFetch<ApplicantHoldsResponse>({ defer: true });

  useEffect(() => {
    if (!activityId) return;

    campfireFetch.run({
      url: `${apiUrl}/vm/activity/event/applicant-holds`,
      method: 'POST',
      data: { activityId },
    });
  }, [activityId, apiUrl]);

  const holds = useMemo(() => {
    return campfireFetch.response?.data?.data?.applicantHolds ?? [];
  }, [campfireFetch.response]);

  return {
    holds,
    isLoading: campfireFetch.isLoading,
    refetch: () => {
      if (activityId) {
        campfireFetch.run({
          url: `${apiUrl}/vm/activity/event/applicant-holds`,
          method: 'POST',
          data: { activityId },
        });
      }
    },
  };
}
